import { createSelector } from 'reselect';

export const getFeatureToggleState = state => state.featureToggle;

export const getIsClientA11yFeatures = createSelector(
  [getFeatureToggleState],
  ({ clientA11yFeatures }) => clientA11yFeatures,
);

export const getAllowPrototypePlaytesting = createSelector(
  [getFeatureToggleState],
  ({ allowPrototypePlaytesting }) => allowPrototypePlaytesting,
);

export const getShowRealTimeUsage = createSelector(
  [getFeatureToggleState],
  ({ showRealTimeUsage }) => !!showRealTimeUsage,
);
